import script from "./content-adapt-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./content-adapt-layout.vue?vue&type=script&setup=true&lang=ts"

import "./content-adapt-layout.vue?vue&type=style&index=0&id=7fa38e27&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa38e27"]])

export default __exports__